import { ComponentClass } from 'react';
export { ComponentClass };

import { createLazyComponent, LazyAction, LazyModule } from 'owa-bundling';
import addNotification from './actions/addNotification';
import removeNotification from './actions/removeNotification';
import SkypeNotificationViewState from './store/schema/SkypeNotificationViewState';
import { default as headerToastNotificationStore } from './store/store';
import {
    CALL_NOTIFICATION_TYPE,
    IM_NOTIFICATION_TYPE,
    SUMMARY_NOTIFICATION_TYPE,
} from './utils/constants';
import { ensureNotificationHandlerRegistered } from './utils/notificationHandler';
import NotificationViewState, {
    NotificationActionType,
} from './store/schema/NotificationViewState';
import NotificationToastProps from './store/schema/NotificationToastProps';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "NotificationToast" */ './lazyIndex')
);

// Delay loaded components
export const NotificationToast = createLazyComponent(lazyModule, m => m.NotificationToast);

// Delay loaded actions
export let lazyAddNotification = new LazyAction(lazyModule, m => m.addNotification);

export {
    addNotification,
    removeNotification,
    NotificationToastProps,
    NotificationViewState,
    NotificationActionType,
    headerToastNotificationStore,
    ensureNotificationHandlerRegistered,
    SkypeNotificationViewState,
    CALL_NOTIFICATION_TYPE,
    IM_NOTIFICATION_TYPE,
    SUMMARY_NOTIFICATION_TYPE,
};
